import {lazy} from 'react';

export const QrCodeLazy = lazy(() => import(/* webpackChunkName: "qrCode" */ '.'));
